import { coreMessages, type AppLocale } from './base-messages';

export const ja: AppLocale = {
  ...coreMessages,
  dataTable: {
    rowModeLabel: 'Row display',
    rowModeEllipsis: 'Truncate (…)',
    rowModeScroll: 'Single line + horizontal scroll',
    rowModeWrap: 'Wrap lines',
    columnsLabel: 'Columns',
    reorderColumnHint: 'Drag the handle to move this column',
    resetThisTablePrefs: 'Reset this table',
    resetThisTablePrefsTitle: 'Clear saved layout for this table only (row mode, columns, order, widths). Does not change your global user settings.',
    dataOperationsLabel: 'データ操作',
    operationExportExcel: 'Excelをダウンロード',
    operationDownloadTemplate: 'テンプレートをダウンロード',
    operationUploadTemplate: 'テンプレートをアップロード',
    operationImportHistory: 'インポート履歴',
    operationFieldDictionary: 'フィールド辞書',
    operationUnsupported: 'このテーブルはこの操作をサポートしていません。',
    operationNoPermission: 'この操作を実行する権限がありません。',
    operationNotReady: 'この操作はまだ準備できていません。',
    customFieldColumnsSectionLabel: 'カスタム項目',
    importModalTitle: 'テンプレートをアップロード',
    importChooseFile: 'CSVファイルを選択',
    importChooseFileHint: 'このテーブルからダウンロードしたテンプレートを入力してアップロードしてください。',
    importNoFile: 'ファイルが選択されていません。',
    importSummary: 'インポート概要',
    importReadyRows: '準備済み行',
    importErrorRows: 'エラー行',
    importWarnings: '警告',
    importUnknownHeaders: '不明な列',
    importMissingRequiredHeaders: '必須列が不足しています',
    importPreview: 'プレビュー',
    importSubmit: 'インポート開始',
    importCancel: 'キャンセル',
    importParsing: 'ファイルを読み込んでいます...',
    importSubmitting: 'インポート中...',
    importNoValidRows: 'インポート可能な有効行がありません。',
    importFailed: 'インポートに失敗しました。',
    importSucceeded: 'インポートが完了しました。',
    operationExportCsv: 'CSVをダウンロード',
    operationExportPdf: 'PDFをダウンロード',
    operationNoRows: 'エクスポートできる表示行がありません。',
    importUnknownHeader: '不明な列: {header}',
    importMissingRequiredHeader: '必須列がありません: {header}',
    importRequiredCell: '{header} は必須です。',
    importMaxRowsExceeded: 'ファイルは {maxRows} 行を超えています。先頭の {maxRows} 行のみ処理しました。',
    refreshLabel: '更新',
    focusModeEnterLabel: '表にフォーカス',
    focusModeFullscreenLabel: '全画面表示',
    focusModeExitLabel: '表のフォーカスを終了',
    horizontalScrollLabel: '表の列をスクロール',
    selectionModeLabel: '行を選択',
    selectAllRowsLabel: 'すべての行を選択',
    selectRowLabel: '行を選択',
    bulkSelectedLabel: '{count} 件選択済み',
    bulkActionsLabel: '一括操作',
    tableSettingsLabel: '表の設定',
    appearanceSectionLabel: '表示',
    columnsSectionLabel: '列',
    rowActionsLabel: '行の操作',
  },
  passwordReset: {
    title: '新しいパスワードを設定',
    description: 'ご本人だけが知る強力な新しいパスワードを設定してください。',
    newPassword: '新しいパスワード',
    confirmPassword: '新しいパスワードを確認',
    passwordHelp: '12 文字以上で、小文字・大文字・数字・特殊文字のうち少なくとも 3 種類を使用してください。',
    mismatch: 'パスワードが一致しません。',
    invalidLink: 'パスワード再設定リンクがない、無効、または期限切れです。',
    submit: 'パスワードを更新',
    submitting: 'パスワードを更新しています...',
    success: 'パスワードを更新しました。新しいパスワードでログインできます。',
    backToLogin: 'ログインに戻る',
    requestTitle: 'パスワード再設定リンクを送信',
    requestDescription: '30 分間有効な一度限りのリンクを、ユーザーの登録メールアドレスに送信します。リンクが使用されるまで現在のパスワードは変更されません。',
    requestSend: 'リンクを送信',
    requestSending: '送信しています...',
    requestSuccess: 'パスワード再設定リンクが送信処理に受け付けられました。',
    requestError: 'パスワード再設定リンクを送信できませんでした。',
    selfServiceOpen: 'パスワードを忘れた場合',
    selfServiceTitle: 'パスワードを忘れた場合',
    selfServiceDescription: '法人アカウントのメールアドレスを入力してください。一致する場合、30分間有効な1回限りのリンクを送信します。',
    selfServiceEmailLabel: 'メールアドレス',
    selfServiceSubmit: 'リンクをリクエスト',
    selfServiceSubmitting: 'リクエストを送信中...',
    selfServiceAcknowledgement: 'このメールアドレスが登録されている場合、再設定リンクが送信されます。受信トレイと迷惑メールをご確認ください。',
    selfServiceClose: '閉じる',
    selfServiceCancel: 'キャンセル',
    selfServiceError: '現在リクエストを完了できません。後でもう一度お試しください。',
    selfServiceRateLimited: 'リクエストが多すぎます。後でもう一度お試しください。',
  },
  relationshipGraph: {
    sourceColumn: '元のレコード',
    relationshipColumn: '関係',
    targetColumn: '関連レコード',
    showDetails: '詳細を表示',
    hideDetails: '詳細を非表示',
    controlsLabel: 'マップ操作',
    title: '関係マップ',
    diagramLabel: 'レコードの関連',
    diagramHelp: 'カードを選択して保存済みの関連を確認します。',
    detailsTitle: 'レコードの詳細',
    connectionsTitle: '接続',
    noConnections: '接続なし',
    loading: '関係を読み込み中…',
    forbidden: 'これらの関係を表示する権限がありません。',
    error: '関係を読み込めませんでした。閉じて再試行してください。',
    empty: 'このレコードには表示できる関連がありません。',
    invalid: '関係データを検証できませんでした。閉じて再試行してください。',
    close: '関係マップを閉じる',
    zoomIn: '拡大',
    zoomOut: '縮小',
    fitView: '全体を表示',
  },
  permissionPicker: {
    application: 'アプリケーション',
    module: 'モジュール',
    action: '操作',
    permissions: '権限',
    description: '説明',
    selection: '選択',
    sharedPermissions: '共有権限',
    selectedPermissions: '{count} 件の権限を選択',
    selectedOnly: '選択済みのみ',
    unselectedOnly: '未選択のみ',
    selectedFirst: '選択済みを先に表示',
    noPermissions: '権限がありません',
  },
  errors: {
    ...coreMessages.errors,
    unknown: '不明なエラーが発生しました',
    network: 'サーバーに接続できません。インターネット接続を確認してください。',
    timeout: 'リクエストがタイムアウトしました。もう一度お試しください。',
    badRequest: '無効なリクエスト',
    unauthorized: 'セッションが期限切れです。再度ログインしてください。',
    forbidden: 'この操作を実行する権限がありません。',
    notFound: 'リクエストされたリソースが見つかりません',
    tooManyRequests: 'リクエストが多すぎます。後でもう一度お試しください。',
    internalServerError: 'サーバーエラー。後でもう一度お試しください。',
    badGateway: 'サーバーが一時的に利用できません',
    serviceUnavailable: 'サービスが一時的に利用できません',
    gatewayTimeout: 'サーバーが応答しません',
    serverErrorWithStatus: 'サーバーエラー ({status})',
  },
  common: {
    databaseUnavailableDeveloperHint: '開発者向けメモ: ローカル開発では、VPNが無効、またはIPが許可されていない場合によく発生します。VPNとデータベースアクセス権を確認してください。',
    ...coreMessages.common,
    requestTimeout: 'The request timed out. Please try again.',
    backendConnectionErrorDev: 'バックエンドサーバーに接続できません。サーバーが起動していることを確認してください（{apiUrl}）。',
    backendConnectionErrorProd: 'バックエンドサーバーに接続できません。後でもう一度お試しください。',
    systemUpdating: 'システムを更新中...',
    serverConfiguring: 'サーバーを設定しています。少々お待ちください...',
    forbidden: 'Access denied.',
    network: 'Network error.',
    select: '選択',
    cancel: 'キャンセル',
    save: '保存',
    saving: '保存中...',
    edit: '編集',
    view: '表示',
    copy: 'コピー',
    delete: '削除',
    appLauncher: 'アプリケーション',
    allApps: 'すべてのアプリケーション',
    loading: '読み込み中...',
    noData: 'データがありません',
    code: 'コード',
    profileMenu: 'プロフィールメニュー',
    selectLanguage: '言語を選択',
    perPage: 'ページあたり',
    firstPage: '最初のページ',
    previousPage: '前のページ',
    nextPage: '次のページ',
    lastPage: '最後のページ',
    pleaseWait: 'お待ちください',
    migrationDescription: 'データベースの更新を適用中です。数秒かかる場合があります。',
    changeText: '変更',
    deleteLogo: 'ロゴを削除',
    logoUploadHint: '最大ファイルサイズ：5MB。対応形式：JPEG、PNG、GIF、WebP',
    deleteAvatar: 'プロフィール写真を削除',
    avatarUploadHint: '最大5MB。JPEG、PNG、GIF、WebP。',
    newRecord: '新規レコード',
    noPermission: '権限がありません',
    searchPlaceholder: '検索...',
    allStatuses: 'すべての状態',
    active: '有効',
    inactive: '無効',
    clearFilters: 'フィルターをクリア',
    all: 'すべて',
    clickToChangeStatus: 'クリックしてステータスを変更',
    noChangePermission: 'ステータスを変更する権限がありません',
    statusDistribution: '状態分布',
    hide: '非表示',
    show: '表示',
    companies: 'Companies',
    adminConsole: '管理コンソール',
    manageAccount: 'アカウント管理',
    manageYourAccount: 'アカウントを管理',
    notificationsTitle: '通知',
    notificationsUnread: '未読',
    notificationsTypesMuted: 'ミュート中の種類',
    notificationsViewAll: 'すべて表示',
    notificationsPreferences: '設定',
    notificationsMutedLabel: 'ミュート',
    notificationsEmpty: '通知はありません',
    selectAll: 'すべて選択',
    id: 'ID',
    remove: '削除',
    syncDeletedResult: '{count} 件の孤立エントリを削除しました。',
    distributionByTable: 'テーブル（コンテキスト）別分布',
    distributionByLocale: '言語別分布',
    translationReport: '翻訳ステータス分布',
    page: 'ページ',
    rows: '行',
    actions: '操作',
    create: '作成',
    search: '検索',
    closeSearch: '検索を閉じる',
    help: 'ヘルプ',
    helpCenter: 'ヘルプセンター',
    helpAboutPage: 'このページについて',
    helpDocumentation: 'ドキュメント',
    helpKeyboardShortcuts: 'キーボードショートカット',
    helpWhatsNew: '新機能',
    helpF1Hint: 'F1キーを押すと、このページのヘルプを表示できます',
    helpNoDocsForPage: 'このページのドキュメントはまだありません',
    aiAssistantTitle: 'QubePro AIアシスタント',
    aiAssistantButton: 'AIアシスタント',
    aiAssistantUnavailable: 'AIアシスタントは現在利用できません。',
    appearancePreference: '外観設定',
    modalControlPlacement: 'フォームコントロール配置',
    modalControlPlacementHint: 'フォームの閉じるボタンと全画面ボタンの位置を設定します。',
    modalControlPlacementSystem: 'システム（推奨）',
    modalControlPlacementWindows: 'Windows',
    modalControlPlacementMacos: 'macOS',
    productTour: {
      start: '製品ツアーを開始',
      restart: '製品ツアーを再開',
      navigationTitle: 'サイドバーとモジュール',
      navigationDescription: 'サイドバーから権限のあるモジュールやページに移動し、各セクションを展開または折りたためます。',
      appsTitle: 'アプリケーション',
      appsDescription: 'ここから QubePro アプリケーションを開き、切り替えることができます。',
      profileTitle: 'プロフィールと会社',
      profileDescription: 'ここでプロフィール、選択中の会社、言語設定を管理できます。',
      aiTitle: 'QubePro AI',
      aiDescription: '現在のページに関するヘルプを得るには、QubePro AI アシスタントを開きます。',
      helpTitle: 'ヘルプセンター',
      helpDescription: 'ドキュメントを開くか、いつでもこの製品ツアーを再開できます。',
      next: '次へ',
      previous: '前へ',
      done: '完了',
      close: '閉じる',
      neverShowAgain: '今後自動的に表示しない',
      progress: '{{current}} / {{total}}',
    },
    userExtensions: '拡張機能',
    close: '閉じる',
    modalFocus: 'フォームに集中',
    modalFullscreen: '全画面表示',
    modalRestore: '元のサイズに戻す',
    filterByColumn: '{column}で絞り込む',
    formCustomFieldsLoading: 'カスタムフィールドを読み込み中…',
    formCustomFieldsLoadError: 'カスタムフィールドを読み込めませんでした。データ損失を防ぐため、保存前に再試行してください。',
    formCustomFieldsRetry: '再試行',
    pageUnavailableTitle: 'ページを開けませんでした',
    pageUnavailableMessage: 'メニューから別のページを開くか、このページを再読み込みしてください。',
    pageReloadWarning: '再読み込みすると未保存の変更は失われます。',
    allTargetLanguages: 'すべての言語（10言語）',
    darkMode: 'ダークモード',
    lightMode: 'ライトモード',
    errorOccurred: 'エラーが発生しました',
    confirm: '確認',
    context: 'テーブル',
    key: '列',
    originalShort: 'Orig.',
    originalValue: '元の値',
    locale: '言語',
    value: '値',
    status: '状態',
    auto: '自動',
    manual: '手動',
    manageLocales: '言語の管理',
    updateUntranslatedFields: '新しいフィールドを同期',
    autoTranslate: '自動翻訳',
    sourceAndTargetMustDiffer: '元の言語と対象言語は異なる必要があります。',
    autoTranslateSuccessCount: '{count} 件を自動翻訳しました。',
    syncEntriesResult: '{count} 件の翻訳を同期しました。',
    translated: 'Translated',
    missing: '未翻訳',
    autoTranslateScope: '自動翻訳の範囲',
    updateUntranslatedFieldsHint: '「新しいフィールドを更新」をクリックして、これらのテーブルからコンテンツを同期します。',
    processing: '処理中...',
    enterTargetLanguage: '対象言語を選択。',
    sourceLanguage: '元の言語',
    selectLanguagesFirst: 'まず言語管理で言語を選択してください',
    sourceLanguageLabel: '元の言語（UI言語）',
    targetLanguage: '対象言語',
    activeLocalesDescription: 'アクティブな言語を選択。設定としてのみ保存。',
    selectSourceLanguageForSync: '既存のコンテンツの言語は？',
    languageNames: {
      en: '英語',
      tr: 'トルコ語',
      de: 'ドイツ語',
      fr: 'フランス語',
      es: 'スペイン語',
      ar: 'アラビア語',
      it: 'イタリア語',
      ja: '日本語',
      zh: '中国語',
      ru: 'ロシア語',
    },
    warning: '警告',
  },
  login: {
    ...coreMessages.login,
    loginFailed: 'ログインに失敗しました',
    emailRequired: 'メールアドレスは必須です',
    passwordRequired: 'パスワードは必須です',
    backendUnavailable: 'サーバーは現在利用できません。後でもう一度お試しください。',
    backendConnectFailed: 'サーバーに接続できません。後でもう一度お試しください。',
    backendConnectFailedDev: 'サーバーに接続できません。サーバーが起動しているか確認してください ({apiUrl})。',
    emailLabel: 'メール',
    emailPlaceholderFull: 'メールアドレスを入力してください',
    passwordLabel: 'パスワード',
    passwordPlaceholderFull: 'パスワードを入力',
    hidePassword: 'パスワードを隠す',
    showPassword: 'パスワードを表示',
    loggingIn: 'ログイン中...',
    submitButton: 'ログイン',
    errors: {
      ...coreMessages.login.errors,
      invalidCredentials: 'メールアドレスまたはパスワードが正しくありません。もう一度お試しください。',
      sessionTooLarge: 'セッションデータが大きすぎます。再度サインインしてください。',
      databaseUnavailable: 'データベースが利用できないか、セットアップが必要です。再度サインインしてください。',
      accountInactive: 'アカウントが有効ではありません。システム管理者にお問い合わせください。',
      sessionExpired: 'セッションの有効期限が切れました。再度サインインしてください。',
      tooManyAttempts: '試行回数が多すぎます。後でもう一度お試しください。',
    },
    featureTitle: "業務と財務の記録をつなぐ",
    featureDescription: "QubePro ERP で在庫、購買、販売、財務の記録を追跡します。",
    featureCard1Title: "製品と在庫",
    featureCard1Description: "製品、倉庫、在庫の移動を管理します。",
    featureCard2Title: "購買",
    featureCard2Description: "購買伝票と発注を追跡します。",
    featureCard3Title: "販売伝票",
    featureCard3Description: "受注と請求書を管理します。",
    featureCard4Title: "財務取引",
    featureCard4Description: "銀行、現金、財務の記録を確認します。",
    darkMode: 'ダークモード',
    lightMode: 'ライトモード',
    pleaseWait: 'お待ちください',
    serverConfiguring: 'サーバーを設定しています。少々お待ちください...',
    dbCreating: 'データベースと必要な設定を作成しています。数秒かかる場合があります。',
    loginPageTitle: 'ログイン',
    languageToggleLabel: '言語選択',
  },
  sidebar: {
    ...coreMessages.sidebar,
    dashboard: 'ダッシュボード',
    settings: '設定',
    toggleMenu: 'メニューを開く',
    toggleMenuClose: 'メニューを閉じる',
    companies: '企業',
    logout: 'ログアウト',
    activityLogs: 'アクティビティログ',
  },
  customFields: {
    title: 'カスタム項目',
    newField: '新規カスタム項目',
    editField: 'カスタム項目を編集',
    entityType: 'レコード種別',
    code: '項目コード',
    label: '表示名',
    codePlaceholder: '例: riskLevel',
    labelPlaceholder: '例: 特別コード 1',
    dataType: 'データ型',
    type: '種別',
    scope: 'スコープ',
    companyId: '会社ID',
    companySelection: '会社',
    companySelectionPlaceholder: '空の場合は全体、または会社を選択',
    selectedCompanies: '{{count}} 社選択済み',
    selectAllCompanies: 'すべての会社を選択',
    sortOrder: '表示順',
    required: '必須',
    searchable: '検索対象',
    showInForm: 'フォームに表示',
    showInList: '列を表示',
    formTab: 'フォームタブ',
    formTabSelect: 'フォームタブ',
    formTabPlaceholder: '空の場合はカスタム項目タブに追加',
    defaultCustomTab: 'カスタム項目',
    selectEntityTypeFirst: '先にレコード種別を選択',
    newFormTab: '新しいタブ',
    tabCode: 'タブコード',
    tabName: 'タブ名',
    tabCodePlaceholder: '例: operations',
    tabNamePlaceholder: '例: 運用情報',
    fieldWidth: '行レイアウト',
    widthFull: '1行に1項目',
    widthHalf: '1行に2項目',
    widthThird: '1行に3項目',
    widthQuarter: '1行に4項目',
    systemField: 'システム項目',
    description: '説明',
    options: '選択肢',
    optionsPlaceholder: '各行: code:ラベル\n例: draft:下書き\nまたは下書きのみ',
    defaultValue: '既定値',
    statusDistributionTitle: '{{title}} ステータス分布',
    emptyMessage: 'カスタム項目はまだ定義されていません。',
    globalScope: '共通',
    companyScope: '会社 {{id}}',
    deleteSelected: '選択項目を削除',
    deleteSelectedMessage: '{{count}} 件のカスタム項目を削除します。この操作は元に戻せません。',
    formDesigner: 'フォーム設計',
    formDesignerTitle: 'カスタム項目フォーム設計',
    formDesignerEntityType: '設計するレコード種別',
    formDesignerAllTabs: 'すべて',
    formDesignerEmpty: 'このレコード種別にはカスタム項目がありません。',
    formDesignerOriginalNotice: '元のフォーム項目は保持されます。この画面ではカスタム項目のタブ、順序、行レイアウトを管理します。',
    formDesignerSave: '設計を保存',
    formDesignerSaved: 'フォーム設計を保存しました。',
    formDesignerMoveUp: '上へ移動',
    formDesignerMoveDown: '下へ移動',
    formDesignerFieldSettings: '項目レイアウト',
    formDesignerQuickSave: '保存',
    formDesignerEditTab: 'タブを編集',
    formDesignerDeleteTab: 'タブを削除',
    formDesignerTabEditorTitle: 'タブ設定',
    formDesignerCloseTabEditor: 'タブエディターを閉じる',
    dataTypes: {
      text: 'テキスト',
      number: '数値',
      date: '日付',
      datetime: '日時',
      boolean: 'はい/いいえ',
      select: '選択',
      json: 'JSON',
    },
  },
  activityLogs: {
    title: 'アクティビティログ',
    searchPlaceholder: '検索（エンティティ、モジュール、操作）…',
    allModules: 'すべてのモジュール',
    allActions: 'すべての操作',
    allSeverity: 'すべての重要度',
    allApps: 'すべてのアプリ',
    startDate: '開始日',
    endDate: '終了日',
    exportCsv: 'CSV をエクスポート',
    total: '合計',
    today: '今日',
    critical: '重大',
    warning: '警告',
    severityInfo: '情報',
    exportFilenameStem: 'activity-logs',
    noLogs: 'アクティビティログは見つかりませんでした。',   system: 'システム',
    field: 'フィールド',
    oldValue: '変更前',
    newValue: '変更後',
    ip: 'IP',
    meta: 'リクエストメタデータ',
    userAgent: 'User-Agent',
    entity: 'エンティティ',
    severityCol: '重要度',
    userCol: 'ユーザー',
    actionCol: '操作',
    moduleCol: 'モジュール',
    dateCol: '日時',
    appCol: 'アプリケーション',
    overviewTitle: '概要',
    severityChart: '重要度の内訳',
    topModulesChart: '件数の多いモジュール',
    csvId: 'ID',
    csvDate: '日時',
    csvUser: 'ユーザー',
    csvAction: '操作',
    csvModule: 'モジュール',
    csvEntity: 'エンティティ',
    csvSeverity: '重要度',
    csvIp: 'IP',
    csvApplication: 'アプリケーション',
    companyCol: '会社 ID',
    allOutcomes: 'すべての結果',
    noLogsDesc: 'ユーザーが操作を実行すると、ここにログが表示されます。',
    entityType: 'レコード種別',
    actorType: '実行者種別',
    outcome: '結果',
    successful: '成功',
    failed: '失敗',
    denied: '拒否',
    reason: '理由',
    requestId: 'リクエスト ID',
    correlationId: '相関 ID',
    integrity: '整合性証明',
    outboxWarning: '監査配信キューへの対応が必要です。',
  },

  // Header Notifications page
  headerNotifications: {
    tabNotifications: '通知',
    tabPreferences: '設定',
    markAllRead: 'すべて既読にする',
    notifCount: '{total} 件の通知',
    unreadCount: '{count} 件未読',
    loading: '通知を読み込み中...',
    noNotifications: '通知はありません',    markRead: '既読にする',
    delete: '削除',   noPreferences: '設定なし',
    noPreferencesDesc: '通知カテゴリがまだありません。通知を受信すると設定が自動的に作成されます。',
    preferencesHeader: 'アプリ内通知設定',
    prefItemDesc: 'このカテゴリの通知をアプリ内で受信する',
    readDistribution: '既読状態の分布',
    readStatusLabel: '既読状態',
    filterAll: 'すべて',
    filterUnread: '未読',
    filterRead: '既読',    colType: '種類',
    colTitle: 'タイトル',
    colMessage: 'メッセージ',
    colDate: '日付',
    colRead: '状態',
    statusUnread: '未読',
    statusRead: '既読',
    searchNotifications: 'タイトルまたはメッセージを検索…',
  },
};
